import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { HeaderWrapper } from '../../../components/ModalResourceHeader.js';
import { ExpandedResourceTitle } from '../../../components/ResourceTitle.js';
import { ExpandedResourceDropdownMenu } from '../../../components/ExpandedResourceDropdownMenu.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import StoredPDFContentWithProvider from '../../../../ExpandedFdoc/ExpandedPDF/StoredPDFContent.js';
import { PDFDropdownItems } from './PDFDropdownItems.js';
import { NoSsr } from '@fabric-app/ui/components/NoSSR';

const ResourceContentDocumentPDF = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsxs(HeaderWrapper, {
        children: [
          /* @__PURE__ */ jsx(HeaderWrapper.Left, {
            children: /* @__PURE__ */ jsx(ExpandedResourceTitle, {})
          }),
          /* @__PURE__ */ jsx(HeaderWrapper.Right, {
            children: /* @__PURE__ */ jsx(ExpandedResourceDropdownMenu, {
              children: /* @__PURE__ */ jsx(PDFDropdownItems, {})
            })
          })
        ]
      }),
      /* @__PURE__ */ jsx(Flex, {
        flexGrow: 1,
        direction: "column",
        justifyContent: "center",
        overflow: "hidden",
        children: /* @__PURE__ */ jsx(NoSsr, {
          children: /* @__PURE__ */ jsx(StoredPDFContentWithProvider, {
            isFullScreen: false,
            tinyPagesIsVisible: false
          })
        })
      })
    ]
  });
};

export { ResourceContentDocumentPDF };
//# sourceMappingURL=ResourceContentDocumentPDF.js.map
